import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  certifyProfessionalApi,
  fetchProfessionals,
} from "../services/professionalsService";

const PROFESSIONALS_QUERY_KEY = ["professionals"];

export const useProfessionals = (options = {}) =>
  useQuery({
    queryKey: PROFESSIONALS_QUERY_KEY,
    queryFn: fetchProfessionals,
    ...options,
  });

export const useCertifyProfessional = ({ method = "put" } = {}) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }) =>
      certifyProfessionalApi(id, payload, method),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: PROFESSIONALS_QUERY_KEY });
      toast.success("Professionnel certifié", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Professionnel non certifié";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};
